import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"font-weight":"bold","margin-bottom":"4px"} }
const _hoisted_2 = { style: {"font-size":"12px","font-weight":"400","margin-bottom":"4px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "no-mb" }
const _hoisted_7 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_8 = {
  key: 1,
  class: "options-mobile"
}
const _hoisted_9 = { style: {"font-size":"12px","font-weight":"400","margin-bottom":"4px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import SubtotalWidget from '@/components/SubtotalWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted } from 'vue'
import { subtotalStore } from '@/stores/subtotal'
import { extraStore } from '@/stores/extra'
import { generalStore } from '@/stores/general'
import SubtotalMobileWidget from '@/components/SubtotalMobileWidget.vue'
import ListExtraOption from '@/components/ListExtraOption.vue'
import { authStore } from '@/stores/auth'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'
import { ls } from '@/ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Extra',
  setup(__props) {

const router = useRouter()

const building = computed(() => ls.get('building'))

const columns = [
  {
    title: 'Optie',
    key: 'external_ref',
    width: 80
  },
  {
    title: 'Omschrijving',
    key: 'option'
  },
  {
    title: 'Prijs incl. BTW',
    key: 'price',
    width: 130
  },
  {
    title: '',
    key: 'actions',
    width: 176
  }
]

onMounted(() => {
  extraStore().getOptions()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Extra opties",
            loading: _unref(extraStore)().loading
          }, {
            extra: _withCtx(() => [
              (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                ? (_openBlock(), _createBlock(UnityWidget, {
                    key: 0,
                    style: { marginRight: '8px' }
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_table, {
                            key: 0,
                            columns: columns,
                            "data-source": _unref(extraStore)().options,
                            pagination: false
                          }, {
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.key === 'external_ref')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(record.external_ref), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'option')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("p", _hoisted_1, _toDisplayString(record.name), 1),
                                    _createElementVNode("p", _hoisted_2, [
                                      (record.inOrder)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Door u besteld in order #" + _toDisplayString(record.inOrder) + ".", 1))
                                        : _createCommentVNode("", true),
                                      (!record.inOrder && record.closing_date)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Deze optie " + _toDisplayString(record.closed ? 'was' : 'is') + " te kiezen tot " + _toDisplayString(record.closing_date ? new Date(record.closing_date).toLocaleString('nl-NL') : null) + ".", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                      innerHTML: record.text_sales
                                    }, null, 8, _hoisted_5)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'price')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("p", _hoisted_6, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                    _createElementVNode("p", _hoisted_7, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.key === 'actions')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (!record.selected)
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 0,
                                          loading: _unref(extraStore)().savingId === record.id,
                                          disabled: _unref(authStore)().restricted() || _unref(extraStore)().savingId !== 0 || _unref(extraStore)().removingId !== 0 || record.closed,
                                          onClick: ($event: any) => (_unref(extraStore)().selectOption(record))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(record.closed ? 'Niet gekozen' : 'Kies'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"]))
                                      : (record.selected)
                                        ? (_openBlock(), _createBlock(_component_a_button, {
                                            key: 1,
                                            type: "primary",
                                            class: "option-btn",
                                            loading: _unref(extraStore)().removingId === record.id,
                                            disabled: _unref(authStore)().restricted() || _unref(extraStore)().savingId !== 0 || _unref(extraStore)().removingId !== 0 || record.closed,
                                            onClick: ($event: any) => (_unref(extraStore)().unselectOption(record))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Gekozen")
                                            ]),
                                            _: 2
                                          }, 1032, ["loading", "disabled", "onClick"]))
                                        : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["data-source"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extraStore)().options, (o) => {
                              return (_openBlock(), _createBlock(ListExtraOption, {
                                option: o,
                                key: o.id
                              }, {
                                subtitle: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_9, [
                                    (o.inOrder)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Door u besteld in order #" + _toDisplayString(o.inOrder) + ".", 1))
                                      : _createCommentVNode("", true),
                                    (!o.inOrder && o.closing_date)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Deze optie " + _toDisplayString(o.closed ? 'was' : 'is') + " te kiezen tot " + _toDisplayString(o.closing_date ? new Date(o.closing_date).toLocaleString('nl-NL') : null) + ".", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                buttons: _withCtx(() => [
                                  (!o.selected)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 0,
                                        loading: _unref(extraStore)().savingId === o.id,
                                        disabled: _unref(authStore)().restricted() || _unref(extraStore)().savingId !== 0 || _unref(extraStore)().removingId !== 0 || o.closed,
                                        onClick: ($event: any) => (_unref(extraStore)().selectOption(o))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(o.closed ? 'Niet gekozen' : 'Kies'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "disabled", "onClick"]))
                                    : (o.selected)
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 1,
                                          type: "primary",
                                          class: "option-btn",
                                          loading: _unref(extraStore)().removingId === o.id,
                                          disabled: _unref(authStore)().restricted() || _unref(extraStore)().savingId !== 0 || _unref(extraStore)().removingId !== 0 || o.closed,
                                          onClick: ($event: any) => (_unref(extraStore)().unselectOption(o))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Gekozen")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"]))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["option"]))
                            }), 128))
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    style: _normalizeStyle(_unref(generalStore)().desktop ? { padding: '8px', textAlign: 'right' } : {})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", {
                        style: _normalizeStyle(_unref(generalStore)().desktop ? { marginRight: 32 } : {})
                      }, "Totaal meer- en minderwerk extra:", 4),
                      _createTextVNode(),
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_12))
                        : _createCommentVNode("", true),
                      _createTextVNode(" € " + _toDisplayString(_unref(subtotalStore)().subtotals.extra), 1)
                    ]),
                    _: 1
                  }, 8, ["style"]),
                  (_unref(extraStore)().options.length && _unref(extraStore)().optionsAvailable && !_unref(authStore)().isDemoCustomer)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_divider),
                          _createVNode(_component_a_row, { style: {"margin-bottom":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", {
                                    style: _normalizeStyle(_unref(generalStore)().desktop ? { margin: '0 0 0 24px' } : { margin: '0' })
                                  }, [
                                    _createTextVNode("De extra opties zijn een aanvulling op de tussen de ondernemer en verkrijger gesloten (koop-) aannemingsovereenkomst."),
                                    _hoisted_13,
                                    _createTextVNode("De Woningborg Garantie- en waarborgregeling is tevens van toepassing op de gekozen extra opties.")
                                  ], 4)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider),
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _unref(extraStore)().agreeToTerms,
                                    disabled: _unref(authStore)().restricted(),
                                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(extraStore)().agreeToTerms = !_unref(extraStore)().agreeToTerms))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Ik/wij ga(an) ermee akkoord dat met het versturen van de opties opdracht gegeven wordt tot de uitvoering van meer- (en minder)werk en dat na de sluitingsdatum deze opties niet meer gewijzigd kunnen worden.")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { class: "no-mb" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    loading: _unref(extraStore)().creatingOrder,
                                    disabled: _unref(authStore)().restricted() || !_unref(extraStore)().agreeToTerms || !_unref(extraStore)().selectedNotOrderedOptions,
                                    style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                                    onClick: _unref(extraStore)().createOrder
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Extra - Bestelling plaatsen")
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled", "style", "onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(SubtotalWidget)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(SubtotalMobileWidget, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})